import { useTranslation } from "react-i18next";
import Button from "../components/button/Button";
import { ModalUtenLocation } from "../components/modal/Modal";
import { loggUt } from "./auth.utils";
import { ButtonGroup } from "../components/button/ButtonGroup";

type Props = {
  handleStillHere: () => void;
  isOpen: boolean;
};

export function ErDuHerModal({ isOpen, handleStillHere }: Props) {
  const { t } = useTranslation("skjematekst", {
    keyPrefix: "auth.erDuHerFortsatt",
  });

  const knapper = (
    <ButtonGroup>
      <Button
        data-testid="loggUtKnapp"
        onClick={() => loggUt()}
        buttonType={"tertiary"}
        text={t("loggUtKnapp")}
        trackingName={"Timeout - Logg ut"}
      />
      <Button
        data-testid="forbliInnloggetKnapp"
        onClick={handleStillHere}
        buttonType={"primary"}
        text={t("forbliKnapp")}
        trackingName={"Forbli innlogget"}
      />
    </ButtonGroup>
  );

  return (
    isOpen && (
      <ModalUtenLocation
        isOpen={isOpen}
        onClose={handleStillHere}
        tittel={t("tittel")}
        knapper={knapper}
      >
        {t("info")}
      </ModalUtenLocation>
    )
  );
}
